import React from 'react';
import { ErrorBoundary } from './errors/ErrorBoundary';

import './CenterLayout.scss';

type CenterLayoutProps = {
  children: React.ReactNode;
};

export const CenterLayout: React.FC<CenterLayoutProps> = ({ children }) => (
  <div className='tw-centerLayout'>
    <main className='tw-centerLayout--inner'>
      <ErrorBoundary>{children}</ErrorBoundary>
    </main>
  </div>
);
